export default (a: string | number, b: string | number): number => {
  const val = typeof a === 'string' ? a : a.toString();
  const val2 = typeof b === 'string' ? b : b.toString();

  return val.localeCompare(val2, 'en', { numeric: true });
};
